import { checkpointPermissionDraft } from './permissionDraft';
const WebviewMessenger = {
    send(message) {
        if (window.ReactNativeWebView) {
            if (['TAKE_MEDICATION_PHOTO', 'PICK_MEDICATION_IMAGE', 'TAKE_PRESCRIPTION_PHOTO', 'PICK_PRESCRIPTION_IMAGE', 'REQUEST_NOTIFICATION_PERMISSION', 'OPEN_NOTIFICATION_SETTINGS', 'OPEN_IOS_NOTIFICATION_SETTINGS', 'REQUEST_FULL_SCREEN_INTENT_PERMISSION', 'SET_IOS_RINGTONE_MODE'].includes(message.type)) checkpointPermissionDraft();
            window.ReactNativeWebView.postMessage(JSON.stringify(message));
        }
    },

    onMessage(callback) {
        const handler = (event) => {
            try {
                const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                callback(data);
            } catch (e) {
                // ignore non-JSON messages
            }
        };
        window.addEventListener('message', handler);
        document.addEventListener('message', handler); // Android
        return () => {
            window.removeEventListener('message', handler);
            document.removeEventListener('message', handler);
        };
    },

    isInWebView() {
        return !!window.ReactNativeWebView;
    },

    openExternalUrl(url, fallbackUrl = null) {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'OPEN_URL', url, fallbackUrl }));
        } else {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    },
};

export default WebviewMessenger;
